export enum DashboardSection {
  tasks = 'tasks',
  classes = 'classes',
  reports = 'reports',
}
